import ImgAVIA from "assets/images/game/table-card/avia.png";
import ImgSPRIBE from "assets/images/game/table-card/spribe.png";
import { SubGameType } from "types/game";

export const LIST_CODE_GAME_ARCADE = {
  AVIATRIX: "AVIA",
  SPRIBE: "SPRI"
};

export const listGameArcade: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: LIST_CODE_GAME_ARCADE.AVIATRIX,
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: ImgAVIA
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: LIST_CODE_GAME_ARCADE.SPRIBE,
    type: "BG",
    featured: "NO",
    new_arrive: "NO",
    picture: ImgSPRIBE
  }
];
